import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogRefreshScreen = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(() => {
    logAnalyticsEvent({
      name: 'REFRESH_SCREEN',
      analytics: { ACTION: 'PULL' },
    });
  }, [logAnalyticsEvent]);
};
